export const hash = '0304789d-a3a6-47c6-86cb-534b4eb6304c';

// export const gateKey = '';
export const gateKey = '';
export const recaptchaKey = '6LdKIrgZAAAAAFCgNLBhpQNO_a29D30zbLGQx9mb';
export const apiUrl = `https://api-global.encontrodigital.com.br/${hash}`;
export const apiSocket = 'https://global-socket.encontrodigital.com.br/';
// export const apiSocket = 'http://localhost:8001';

//export const apiUrl = `http://localhost:8000/${hash}`;
export const urlWebsite = 'https://qualidadeevaloremsaude.encontrodigital.com.br';
export const supportNumber = `5551981476007`;
export const home = 'Home';
// export const urlWebsite = 'http://localhost:3000';
export const eventName = 'IV Fórum da Qualidade do Hospital Mãe de Deus e I Summit Internacional de Valor em Saúde do Hospital Mãe de Deus';
export const logo = '/assets/logo.png';
export const background = '/assets/Fundo.jpg';
export const authTitle = 'IV Fórum da Qualidade do Hospital Mãe de Deus e I Summit Internacional de Valor em Saúde do Hospital Mãe de Deus';
export const social = {
  whatsapp: '',
  instagram: 'hospitalmaededeus/',
  facebook: 'HospitalMaedeDeus',
  linkedin: 'company/hospital-mae-de-deus',
  youtube: 'channel/UC8rKF6YxDsR5DVjPQayBgNw',
  twitter: '',
};

export const defaultTheme = {
  defaultBackground: 'rgb(0,15,64)',
  defaultColor: '#fff',
  logo: {
    minWidth: '450px',
  },
  menu: {
    background: 'none',
    backgroundSticky: 'none',
    backgroundMobile: 'rgb(0,15,64)',
    color: '#fff',
    shadow: '0',
    logoColor: 'none',
  },
};

export const getToken = (): string | null => {
  const token = localStorage.getItem(`@${authTitle}:token`);
  return token;
};
